export default __webpack_public_path__ + "static/media/girl.2e681d21.png";